import styled, { keyframes } from 'styled-components';
import type { LoaderProps } from '.';

const clockwise = keyframes`
  0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); }
`;

const donutRotate = keyframes`
  0% { -webkit-transform: rotate(0); transform: rotate(0); }
  50% { -webkit-transform: rotate(-140deg); transform: rotate(-140deg); }
  100% { -webkit-transform: rotate(0); transform: rotate(0); }
`;

export const PreloaderIcon = styled.div<LoaderProps>`
  opacity: 0.75;
  width: ${({ size }) => (size ? `${size}px` : '28px')};
  height: ${({ size }) => (size ? `${size}px` : '28px')};
  margin: 0 auto;
  -webkit-animation: ${clockwise} 500ms linear infinite;
  animation: ${clockwise} 500ms linear infinite;
`;

export const PreloaderCut = styled.div<LoaderProps>`
  position: relative;
  width: 7px;
  height: ${({ size }) => (size ? `${size}px` : '28px')};
  overflow: hidden;
`;

export const PreloaderDonut = styled.div<LoaderProps>`
  box-sizing: border-box;
  width: ${({ size }) => (size ? `${size}px` : '28px')};
  height: ${({ size }) => (size ? `${size}px` : '28px')};
  border: ${({ theme }) => `2px solid ${theme.color25}`};
  border-radius: 50%;
  border-left-color: transparent;
  border-bottom-color: transparent;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-animation: ${donutRotate} 1000ms cubic-bezier(0.4, 0, 0.22, 1)
    infinite;
  animation: ${donutRotate} 1000ms cubic-bezier(0.4, 0, 0.22, 1) infinite;
`;
